<template>
  <article class="CscEventsList">
    <header-background
      image-src="/img/backgrounds/csc-01.jpg"
      title="Processos Seletivos e Concursos"
      class="CscEventsList-Header"
    />

    <section
      class="CscEventsList-Section"
    >
      <the-title>Redirecionando...</the-title>

      <p class="CscEventsList-Paragraph">
        Por favor, aguarde alguns instantes enquanto você é redirecionado para nosso sistema de eventos.
      </p>

      <p class="CscEventsList-Paragraph">
        Se isso não acontecer automaticamente, <a href="https://csc.selecao.net.br/" target="_blank">clique aqui</a>.
      </p>

      <p class="CscEventsList-Paragraph">
        Ou <a
          class="CscEventsList-Link"
          title="Clique para voltar para a página inicial."
          @click="goHome()"
        >clique aqui</a> para voltar para a página inicial.
      </p>
    </section>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .CscEventsList {
    &-Section {
      margin: 20px 0;
    }

    &-Paragraph {
      margin: 10px;
      font-size: 20px;
    }
  }
</style>

<script>
  import TheTitle from "@/components/TheTitle";
  import HeaderBackground from "../components/HeaderBackground";

  export default {
    name: "Events",

    components: {
      HeaderBackground,
      TheTitle,
    },

    beforeMount() {
      window.open("https://csc.selecao.net.br/", "_blank", "noopener,noreferrer");
    },

    methods: {
      goHome() {
        this.$router.push({ path: "/" }).catch(() => {});
      },
    },
  };
</script>
